import { render, staticRenderFns } from "./OnboardingHeader.vue?vue&type=template&id=2e707ce7&"
import script from "./OnboardingHeader.vue?vue&type=script&lang=js&"
export * from "./OnboardingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports